import { Button, Image, UIHeading2, UIText2 } from '@cian/ui-kit';

import { type FC } from 'react';

import errImg from './err.png';

import styles from './ListingLoadErrorView.css';

type ListingLoadErrorViewProps = {
  navigation?: JSX.Element;
  isLoading: boolean;
  onRetry(): void;
};

export const ListingLoadErrorView: FC<ListingLoadErrorViewProps> = props => {
  const { isLoading, onRetry } = props;

  return (
    <div className={styles['container']}>
      <Image alt="Ошибка загрузки объявлений" height={80} src={errImg} width={80} />

      <div className={styles['heading-wrapper']}>
        <UIHeading2 as="h2">Что-то пошло не так</UIHeading2>
      </div>

      <UIText2>Пожалуйста, повторите загрузку&nbsp;— должно получиться</UIText2>

      <div className={styles['button-wrapper']}>
        <Button disabled={isLoading} loading={isLoading} type="button" onClick={onRetry}>
          Повторить
        </Button>
      </div>
    </div>
  );
};
